import {
  Box,
  List,
  ListItem,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useAssetOutlet } from "../../asset";
import { AssetRiskFactor } from "~/operations";
import { Flex } from "~/components/Flex";
import { RiskFactorsChip } from "~/components/RiskFactorsChip/RiskFactorsChip";
import { WarningIcon } from "~/icons";

export function RiskFactors() {
  const { asset, loading } = useAssetOutlet();
  const { riskFactors } = asset;

  const affectedRiskFactors = riskFactors?.filter(
    (riskFactor) => riskFactor.isDetected,
  );

  return (
    <Box component={Paper} sx={{ p: 3, minHeight: 320, overflow: "hidden" }}>
      <Stack direction="row" justifyContent="space-between">
        <Typography
          variant="h5"
          component="h3"
          fontWeight={700}
          sx={{ color: "text.primary", lineHeight: "24px", pb: 3 }}
        >
          RISK FACTORS
        </Typography>
        <WarningIcon />
      </Stack>
      <List disablePadding sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {loading ? (
          <RiskFactorsLoading />
        ) : affectedRiskFactors?.length ? (
          <RiskFactorsList affectedRiskFactors={affectedRiskFactors} />
        ) : (
          <Flex
            alignItems="center"
            justifyContent="center"
            sx={{ height: 150 }}
          >
            <Typography sx={{ fontWeight: 500, color: "text.secondary" }}>
              NO RISK FACTORS
            </Typography>
          </Flex>
        )}
      </List>
    </Box>
  );
}

const RiskFactorsList = ({
  affectedRiskFactors,
}: {
  affectedRiskFactors: AssetRiskFactor[];
}) => {
  return (
    <>
      {affectedRiskFactors?.map((riskFactor) => {
        return (
          <ListItem key={riskFactor.mrn} sx={{ p: 0, width: "unset" }}>
            <RiskFactorsChip riskFactor={riskFactor} />
          </ListItem>
        );
      })}
    </>
  );
};

const RiskFactorsLoading = () => {
  // Simulate loading state with skeletons
  return (
    <>
      {[...Array(3)].map((_, index) => (
        <ListItem key={index} sx={{ px: 0, width: "unset" }}>
          <Skeleton
            variant="rounded"
            width={140 + index * 20}
            height={32}
            animation="wave"
            sx={{ borderRadius: 50 }}
          />
        </ListItem>
      ))}
    </>
  );
};
